import { GLTFExporter } from "three/examples/jsm/exporters/GLTFExporter";
import { Document, Page, View, pdf } from "@react-pdf/renderer";

export function FileDownload(url, name) {
  if (url) {
    const link = document.createElement("a");
    link.href = url;
    link.download = name ? name : url.split("?")[0].split("/").at(-1); // Extract name from url if name not passed
    link.click();
    link.remove();
  }
}

const MyPdfDocument = (pdfBody) => (
  <Document>
    <Page>
      <View>{pdfBody}</View>
    </Page>
  </Document>
);

export const getPdfForScene = async (pdfBody) => {
  const pdfBlob = await pdf(MyPdfDocument(pdfBody)).toBlob();
  return URL.createObjectURL(pdfBlob);
};

export function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

export async function handleExportGLTF({
    currentScene,
    scene,
    fileName,
    setLoading,
  }) {
    console.log("dekho : scene", scene);
    console.log("dekho : model", currentScene);
    setLoading?.(true);
    const gltfExporter = new GLTFExporter();
    const gltf = await new Promise((resolve) => {
      gltfExporter.parse(currentScene, (result) => {
        console.log("Parsed GLTF result:", result);
        resolve(result);
      });
    });
  
    const blob = new Blob([JSON.stringify(gltf)], { type: "model/gltf" });
    const fileFormData = new FormData();
    fileFormData.append("file_url_key", `${fileName}.glb`);
    try {
      const createFileSpaceResponse = await fetch(
        "https://prod.imagine.io/users/api/v3/public/dynamic-ar-data/",
        {
          method: "POST",
          body: fileFormData,
        }
      ).then((res) => res.json());
      if (!createFileSpaceResponse) {
        return;
      }
      const { data } = createFileSpaceResponse || {};
      const unicodeApiUrl =
        "https://prod.imagine.io/users/api/v3/public/dynamic-ar-data/?unicode=" +
        data?.unicode;
      const presignedUrlData = data?.presigned_url_file;
      const presignedFields = presignedUrlData.fields;
      console.log({
        createFileSpaceResponse,
        unicodeApiUrl,
        presignedUrlData,
        presignedFields,
      });
      const fileUploadFormData = new FormData();
      for (const key in presignedFields) {
        fileUploadFormData.append(key, presignedFields[key]);
      }
      fileUploadFormData.append("file", blob, `${fileName}.glb`);
      // Here, we are uploading the file to S3 using the presigned URL
      const uploadedFileResponse = await fetch(presignedUrlData.url, {
        method: "POST",
        body: fileUploadFormData,
      });
      if (!uploadedFileResponse.ok) {
        throw new Error("Failed to upload file to S3");
      }
      console.log("File uploaded to S3");
      // Here, we are fetching the file from S3 using the unicode API
      const fileFetchedViaUnicode = await fetch(unicodeApiUrl).then((r) =>
        r.json()
      );
      console.log("DEBUG__finalData", {
        fileFetchedViaUnicode,
        uploadedFileResponse,
        unicodeApiUrl,
      });
      setLoading?.(false);
      return {
        file: fileFetchedViaUnicode?.data?.file,
        unicode: data?.unicode,
      };
    } catch (error) {
      console.error("Error:", error);
      setLoading?.(false);
    }
  }
  export const isAndroid = () => navigator.userAgent.match(/Android/i);